import { createFileRoute } from "@tanstack/react-router";

import { About } from "@/components/site/About";
import { Enroll } from "@/components/site/Enroll";
import { Experience } from "@/components/site/Experience";
import { Hero } from "@/components/site/Hero";
import { InstagramFeed } from "@/components/site/InstagramFeed";
import { Included } from "@/components/site/Included";
import { Pathways } from "@/components/site/Pathways";
import { Publications } from "@/components/site/Publications";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SiteHeader } from "@/components/site/SiteHeader";
import { LanguageProvider } from "@/i18n/language";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Share The Med (STM) | Mentoría en investigación médica" },
      {
        name: "description",
        content:
          "Programa bilingüe de mentoría científica para estudiantes, residentes y médicos: reportes de caso, revisiones narrativas y revisiones sistemáticas con acompañamiento editorial.",
      },
      { property: "og:title", content: "Share The Med (STM) | Mentoría en investigación médica" },
      {
        property: "og:description",
        content:
          "Mentoría científica estructurada para publicar investigación médica: rutas básica, intermedia y avanzada con acompañamiento editorial.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <LanguageProvider>
      <SiteHeader />
      <main>
        <Hero />
        <About />
        <Experience />
        <Pathways />
        <Publications />
        <Included />
        <InstagramFeed />
        <Enroll />
      </main>
      <SiteFooter />
    </LanguageProvider>
  );
}
